import { render, staticRenderFns } from "./PromotionActionDelete.vue?vue&type=template&id=653de1b8&"
import script from "./PromotionActionDelete.vue?vue&type=script&lang=ts&"
export * from "./PromotionActionDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports